import { i18n } from '@/locale';

export default {
    data () {
        return {};
    },
    methods: {
        imgsrc (src) {
            return '/api/upl/s3/download/big/file?_id=' + src;
        },
        returnHome () {
            this.$router.replace({
                name: 'modelList',
            });
        },
        // 将从服务器获取的表单数据的结构打平成数组，并加入『左眼』『右眼』『眼睑』『指甲』之类的小标题对象
        formatParameters (paramList, tipKey = 'gzzoc.imgTip') {
            let params = [];
            let keyType = ['public', 'left_eye', 'right_eye', 'model', 'eyelid', 'nail', 'eye_imgs', 'quality_type', 'fundus_imags'];
            for (let key of keyType) {
                if (key === 'left_eye') {
                    if (paramList[key] && paramList[key].length) {
                        params.push({
                            data_type: 'title',
                            title: i18n.t('gzzoc.leftEyeTitle', {year: 10}),
                            tip: i18n.t(tipKey),
                            name: 'left',
                            key_type: key
                        });
                    }
                } else if (key === 'right_eye') {
                    if (paramList[key] && paramList[key].length) {
                        params.push({
                            data_type: 'title',
                            title: i18n.t('gzzoc.rightEyeTitle', 11),
                            tip: i18n.t(tipKey),
                            name: 'right',
                            key_type: key
                        });
                    }
                } else if (key === 'model') {
                    if (paramList[key] && paramList[key].length) {
                        params.push({
                            data_type: 'title',
                            title: i18n.t('gzzoc.diagnosisTypeTitle', 11),
                            tip: '',
                            name: 'type',
                            key_type: key
                        });
                    }
                } else if (key === 'eyelid') {
                    if (paramList[key] && paramList[key].length) {
                        params.push({
                            data_type: 'title',
                            title: i18n.t('gzzoc.eyelidTitle', 11),
                            tip: '',
                            name: 'eyelid',
                            key_type: key
                        });
                    }
                } else if (key === 'nail') {
                    if (paramList[key] && paramList[key].length) {
                        params.push({
                            data_type: 'title',
                            title: i18n.t('gzzoc.nailTitle', 11),
                            tip: '',
                            name: 'nail',
                            key_type: key
                        });
                    }
                } else if (key === 'eye_imgs') {
                    if (paramList[key] && paramList[key].length) {
                        params.push({
                            data_type: 'title',
                            title: i18n.t('gzzoc.eyeImgsTitle', 11),
                            tip: '',
                            name: 'eye_imgs',
                            key_type: key
                        });
                    }
                }
                let list = paramList[key];
                if (list) {
                    for (let item of list) {
                        // key_type，方便getParameterValue进行组装
                        item.key_type = key;
                        params.push(item);
                    }
                }
            }
            return params;
        },
        // 提交表单时，将打平成数组的表单数据组装成原来的结构
        getParameterValue () {
            let parameters = this.model.parameters;
            let value = {};
            for (let item of parameters) {
                if (item.data_type === 'title') {
                    continue;
                }
                let key = item.key_type;
                if (!value[key]) {
                    value[key] = [];
                }
                let val = item.value;
                if (item.data_type === 'number') {
                    val = Number.parseFloat(val);
                }
                value[key].push({
                    name: item.name,
                    value: val
                });
            }
            return value;
        }
    }
};
